import { FC, useState, useEffect, memo } from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import Auth from 'store/auth'
import BtnLecturSubscribe from 'components/parts/btn-lectur-subscribe/btn-lectur-subscribe'
import LectorBioText from './lector-bio-text'
import useAlert from 'store/common/useAlert'

import { handleSubscription } from 'utils/handleLecturSubscription'
import { generateLectorTumbnail } from 'utils/genereateLectorTumbnail'
import { cutHashFromURL } from 'utils/getURLData'
import { ILectorCard } from 'constants/types/card.types'
import { STATIC_PREVIEW_URL, currImageDomain } from 'constants/data'
import { PLACEFLAG_LECTOR_PERSONAL } from 'constants/analytic-data'
import { lectorOrigin } from 'utils/analytics/other/sub_lector/sub_lector'
import { popupName } from 'constants/auth/auth-data'

import styles from './lector-bio.module.scss'

const LectorBio: FC<ILectorCard> = ({
  firstName,
  secondName,
  lastName,
  Specialities,
  previewName,
  description,
  id,
  subscribed,
  regalia,
}: ILectorCard) => {
  const router = useRouter()
  const { isAuthorized } = Auth.useAuth()
  const { setSingleAlert } = useAlert()
  const [isSubscribed, setSubscribed] = useState(Boolean(subscribed))

  const path = cutHashFromURL(router.asPath)

  const lectorPreview = previewName ? (
    <img
      src={`${currImageDomain}${STATIC_PREVIEW_URL}/lectur/${previewName}`}
      className={clsx(styles.cardImage, styles.noText)}
      alt="lector avatar"
      decoding="async"
      loading="lazy"
    />
  ) : (
    <div className={styles.cardImage}>
      {firstName && lastName ? generateLectorTumbnail(undefined, `${firstName} ${lastName}`) : ''}
    </div>
  )

  const specialities = Specialities.length
    ? Specialities.map((speciality) => speciality.name).join(', ')
    : ''

  const subscribeLectur = async () => {
    if (isAuthorized) {
      await handleSubscription(
        isSubscribed,
        PLACEFLAG_LECTOR_PERSONAL,
        id as number,
        setSubscribed,
        setSingleAlert
      )
    } else {
      router.push(`${path}#${popupName.registration}`, undefined, { shallow: true })
    }
  }

  useEffect(() => {
    setSubscribed(Boolean(subscribed))
  }, [subscribed])

  return (
    <div className={styles.author}>
      <div className={styles.authorTop}>
        <div className={styles.imageDesktop}>{lectorPreview}</div>
        <div className={styles.authorWrapper}>
          <div className={styles.authorDescription}>
            <div className={styles.imageMobile}>{lectorPreview}</div>
            <div className={styles.authorText}>
              <p className={styles.authorName}>
                <span>{lastName} </span>
                <span>{firstName} </span>
                <span>{secondName}</span>
              </p>
              <p className={styles.specialities}>{specialities}</p>
            </div>
          </div>
          <div className={styles.buttonTop} onClick={subscribeLectur}>
            <BtnLecturSubscribe
              origin={isAuthorized ? lectorOrigin.LECTUR_PAGE : lectorOrigin.NOORIGIN}
              isSubscribed={isSubscribed}
              idLector={id}
            />
          </div>
        </div>
      </div>
      <LectorBioText description={description} Specialities={Specialities} regalia={regalia} />
    </div>
  )
}

export default memo(LectorBio)
